var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#33233d;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.082 7.792)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.37,5.947a7.466,7.466,0,0,0,1.875-1.942h0A7.811,7.811,0,0,1,16.09,4.6a3.72,3.72,0,0,0,1.646-2.067,7.484,7.484,0,0,1-2.372.905,3.74,3.74,0,0,0-6.47,2.557,3.851,3.851,0,0,0,.087.853A10.59,10.59,0,0,1,1.27,2.931a3.74,3.74,0,0,0,1.149,5A3.7,3.7,0,0,1,.73,7.469v.041a3.758,3.758,0,0,0,3,3.676,3.719,3.719,0,0,1-.981.123,3.3,3.3,0,0,1-.708-.064,3.777,3.777,0,0,0,3.495,2.606A7.519,7.519,0,0,1,.895,15.446,7.074,7.074,0,0,1,0,15.4a10.533,10.533,0,0,0,5.738,1.679A10.573,10.573,0,0,0,16.37,5.947Z",
    transform: "translate(0 -2.25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c11e487118ab46cd9decd68954c68900.svg";
export { ForwardRef as ReactComponent };